(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-gallery-description"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.pgd').forEach((pgd) => {
      const slider = pgd.querySelector('.pgd__gallery-slider');
      const dotsContainer = pgd.querySelector('.pgd__dots');

      if (!slider) return;

      const isDesktop = () => window.innerWidth >= 1024;

      function updateDots() {
        if (!dotsContainer || isDesktop()) return;
        const dots = dotsContainer.querySelectorAll('.pgd__dot');
        const items = slider.querySelectorAll('.pgd__gallery-item');
        if (!items.length) return;
        const itemWidth = items[0].offsetWidth + 10;
        const activeIndex = Math.round(slider.scrollLeft / itemWidth);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
      }

      slider.addEventListener('scroll', updateDots, { passive: true });

      let isDown = false;
      let startX, scrollLeft, velocity, lastX, raf;

      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('is-dragging');
        document.body.style.userSelect = 'none';
        startX = e.pageX;
        scrollLeft = slider.scrollLeft;
        velocity = 0;
        lastX = e.pageX;
        cancelAnimationFrame(raf);
      });

      slider.addEventListener('mouseup', () => {
        if (!isDown) return;
        isDown = false;
        slider.classList.remove('is-dragging');
        document.body.style.userSelect = '';
        momentum();
      });

      slider.addEventListener('mouseleave', () => {
        if (!isDown) return;
        isDown = false;
        slider.classList.remove('is-dragging');
        document.body.style.userSelect = '';
        momentum();
      });

      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        slider.scrollLeft = scrollLeft - (e.pageX - startX);
        velocity = e.pageX - lastX;
        lastX = e.pageX;
      });

      function momentum() {
        velocity *= 0.95;
        slider.scrollLeft -= velocity;
        if (Math.abs(velocity) > 0.5) {
          raf = requestAnimationFrame(momentum);
        } else {
          updateDots();
        }
      }

      let touchStartX, touchScrollLeft;

      slider.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].pageX;
        touchScrollLeft = slider.scrollLeft;
      }, { passive: true });

      slider.addEventListener('touchmove', (e) => {
        slider.scrollLeft = touchScrollLeft - (e.touches[0].pageX - touchStartX);
      }, { passive: true });

      slider.addEventListener('touchend', updateDots, { passive: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-personalise"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.product-personalise-block').forEach((block) => {
    const slider = block.querySelector('.product-personalise-gallery__slider');
    const controls = block.querySelector('.product-personalise-gallery__controls');

    if (!slider) return;

    const prevButton = controls?.querySelector('[data-personalise-prev], .slideshow-control--previous, .custom__carousel-nav-btn--prev');
    const nextButton = controls?.querySelector('[data-personalise-next], .slideshow-control--next, .custom__carousel-nav-btn--next');

    function getStep() {
      const item = slider.querySelector('.product-personalise-gallery__item');
      if (!item) return 0;
      return item.offsetWidth + 20;
    }

    function updateButtons() {
      if (!prevButton || !nextButton) return;

      const maxScroll = slider.scrollWidth - slider.clientWidth;
      prevButton.disabled = slider.scrollLeft <= 0;
      nextButton.disabled = slider.scrollLeft >= maxScroll - 2;
    }

    slider.addEventListener('scroll', () => {
      updateButtons();
    }, { passive: true });

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        slider.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        slider.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }

    let isDown = false;
    let startX, scrollLeft, velocity, lastX, raf;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('is-dragging');
      document.body.style.userSelect = 'none';
      startX = e.pageX;
      scrollLeft = slider.scrollLeft;
      velocity = 0;
      lastX = e.pageX;
      cancelAnimationFrame(raf);
    });

    slider.addEventListener('mouseup', () => {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('is-dragging');
      document.body.style.userSelect = '';
      momentum();
    });

    slider.addEventListener('mouseleave', () => {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('is-dragging');
      document.body.style.userSelect = '';
      momentum();
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      slider.scrollLeft = scrollLeft - (e.pageX - startX);
      velocity = e.pageX - lastX;
      lastX = e.pageX;
    });

    function momentum() {
      velocity *= 0.95;
      slider.scrollLeft -= velocity;
      if (Math.abs(velocity) > 0.5) {
        raf = requestAnimationFrame(momentum);
      } else {
        updateButtons();
      }
    }

    let touchStartX, touchScrollLeft;

    slider.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].pageX;
      touchScrollLeft = slider.scrollLeft;
    }, { passive: true });

    slider.addEventListener('touchmove', (e) => {
      slider.scrollLeft = touchScrollLeft - (e.touches[0].pageX - touchStartX);
    }, { passive: true });

    slider.addEventListener('touchend', () => {
      updateButtons();
    }, { passive: true });

    updateButtons();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["legacy-stock-badge"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.product-info__stock[data-product-id]').forEach((badge) => {
      const section = badge.closest('.shopify-section, dialog');
      if (!section) return;

      section.addEventListener('variant:update', (event) => {
        const eventProductId = event.target instanceof HTMLElement ? event.target.dataset.productId : null;
        if (eventProductId && eventProductId !== badge.dataset.productId) return;

        const newBadge = event.detail.data.html.querySelector('.product-info__stock');
        if (!newBadge) return;
        badge.innerHTML = newBadge.innerHTML;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
